<template>
    <div>
        <div class="loading-spinner-outer" v-if="loading">
          <div class="loading-spinner-inner">
            <div class="loading-spinner"></div>
          </div>
        </div>
        <div class="box" v-if="!loading">
            <div class="box-content">
                <form method="POST" action="/user-update" id="update_customer_form">
                    <input type="hidden" name="_token" v-model="csrfToken">
                    <input type="hidden" name="user_id" v-model="user.id">
                    <input type="hidden" name="company_id" v-model="user.company_id" v-if="change_company_active === false">
                    <div class="flex-xs">
                        <div class="half-width-xs pr-3-xs">
                            <div class="form-group" v-show="user.formatted_latest_black_ice_access_date !== '' && logged_in_user.isStaff">
                                <span>Last Black ICE access:</span> {{ user.formatted_latest_black_ice_access_date }}
                            </div>
                            <div class="form-group">
                                <label>Name</label>
                                <input type="text" name="name" v-model="user.name" class="form-control" required>
                            </div>
                            <div class="form-group">
                                <label>Phone Number</label>
                                <input type="text" name="phone" v-model="user.phone" class="form-control" required>
                            </div>
                            <div class="form-group">
                                <label>Email Address</label>
                                <input type="text" name="email" v-model="user.email" class="form-control" required>
                            </div>
                            <div class="form-group" v-if="logged_in_user.isAdmin">
                              <label>Login Type</label>
                              <select class="form-control" name="auth_type_id" v-model="user.auth_type_id">
<!--                                <option value="1">Password Only</option>-->
                                <option value="2">MFA - Email Code</option>
                                <option value="3">Azure Login</option>
                              </select>
                            </div>
                            <div class="form-group">
                                <label>Lead Recipient</label>
                                <div class="radios _inline">
                                    <label class="radio">
                                        <input type="radio" v-model="user.lead_recipient" name="lead_recipient" :value="1" :disabled="!user_can_be_lead_recipient">
                                        <span class="radio-label">Yes</span>
                                    </label>
                                    <label class="radio">
                                        <input type="radio" v-model="user.lead_recipient" name="lead_recipient" :value="0">
                                        <span class="radio-label">No</span>
                                    </label>
                                </div>
                                <div class="mt-2 txt-sm txt-danger" v-if="!user_can_be_lead_recipient">
                                    Company has maximum of 3 lead recipients.
                                </div>
                            </div>
                            <div class="form-group" v-if="logged_in_user.isStaff">
                              <label>Temporary Login</label>
                              <div class="radios _inline">
                                <label class="radio">
                                  <input type="radio" v-model="user.temporary_login" name="temporary_login" :value="1">
                                  <span class="radio-label">Yes</span>
                                </label>
                                <label class="radio">
                                  <input type="radio" v-model="user.temporary_login" name="temporary_login" :value="0">
                                  <span class="radio-label">No</span>
                                </label>
                              </div>
                            </div>
                            <div class="form-group" v-if="user.temporary_login">
                              <label>Temporary Login Expiration Date</label>
                              <datepicker input-class="form-control" v-model="user.temporary_login_expires_at" name="temporary_login_expires_at"></datepicker>
                            </div>
                            <div class="form-group" v-if="logged_in_user.isStaff">
                                <label>Company</label>
                                <div class="flex justify-between">
                                    <div>
                                        <a :href="`/company/${user.company_id}`">
                                            {{ user.company.name }} <i class="fal fa-eye"></i>
                                        </a>
                                    </div>
                                    <div class="pl-3">
                                        <a class="btn-primary _sm" @click.prevent="openChangeCompanySection()" v-if="change_company_active === false">
                                            Change Company
                                        </a>
                                        <a class="btn-danger _sm" @click.prevent="change_company_active = false" v-if="change_company_active === true">
                                            Cancel
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                      <div class="half-width-xs pl-3-xs" v-if="logged_in_user.isStaff && user.isACP">
                        <div class="form-group">
                          <strong class="txt-primary mb-2 block">Commercial Section Access:</strong>
                          <div class="checkbox" v-for="commercial_section in commercial_sections">
                            <label>
                              <input type="checkbox"
                                     v-model="user_access_sections_list"
                                     :value="commercial_section.id"
                                     name="user_access_sections_list[]"
                              >
                              <span class="checkbox-label">{{ commercial_section.label }}</span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <template v-if="change_company_active && logged_in_user.isStaff">
                        <hr class="mb-6 mt-6">
                        <div class="flex-xs mb-6">
                            <div>
                                <h3 class="txt-primary pr-3-xs">
                                    Select which company this user belongs to:
                                </h3>
                            </div>
                            <div class="flex-2xs justify-end ml-a">
                              <div class="flex justify-end ml-a mb-1 mb-0-2xs">
                                <div class="pr-1">
                                  <a class="btn-primary" @click.prevent="refreshCompanies()">
                                    <i class="fal fa-sync"></i>
                                  </a>
                                </div>
                                <div class="pr-1-2xs">
                                  <a class="btn-primary" href="/company/create" target="_blank">
                                    Add New
                                  </a>
                                </div>
                              </div>
                              <div class="pr-1-2xs mb-1 mb-0-2xs">
                                <div class="multi-select-input" @click.stop="filter_dropdown_open = !filter_dropdown_open" style="min-width:165px;">
                                  <div class="multi-select-input-placeholder">
                                    Filter...
                                    <div class="dropdown-icon">
                                      <i class="fal fa-chevron-down"></i>
                                    </div>
                                  </div>
                                  <div class="multi-select-input-inner" v-show="filter_dropdown_open">
                                    <div class="multi-select-input-group mt-3">
                                      <h1 class="input-group-title">Company Types</h1>
                                      <div class="checkboxes">
                                        <div class="checkbox level-1" v-for="company_type in all_company_types">
                                          <label>
                                            <input type="checkbox" name="selected_company_types" :value="company_type.id" v-model="selected_company_types">
                                            <span class="checkbox-label">{{ company_type.label }}</span>
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="multi-select-input-group">
                                      <h1 class="input-group-title">System Types</h1>
                                      <div class="checkboxes">
                                        <div class="checkbox level-1" v-for="system_type in all_epwin_system_types">
                                          <label>
                                            <input type="checkbox" name="selected_system_types" :value="system_type.id" v-model="selected_system_types">
                                            <span class="checkbox-label">{{ system_type.label }}</span>
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                                <div>
                                    <input type="text" placeholder="Search" class="form-control" v-model="companies_search_query">
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                          <div class="relative">
                            <div style="position: absolute; top:0; left:0; right: 0; bottom: 0; background:white; opacity: 0.8;" v-show="filtering"></div>
                            <table class="table _lined">
                                <tbody>
                                <tr v-for="(company, index) in companies">
                                    <td style="width: 40px;">
                                        <input type="radio" name="company_id" v-model="user.company_id" :value="company.id" :id="`company_${company.id}`">
                                    </td>
                                    <td style="width: 125px;">
                                        <label :for="`company_${company.id}`">
                                            {{ company.account_code }}
                                        </label>
                                    </td>
                                    <td>
                                        <label :for="`company_${company.id}`">
                                            {{ company.name }}
                                        </label>
                                    </td>
                                    <td class="align-right" style="width: 40px;">
                                        <a :href='"/company/"+company.id' class="txt-primary pl-3" target="_blank">
                                            <i class="fa fa-eye"></i>
                                        </a>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                          </div>
                            <template>
                                <div class="pagination-bar wrapper mb-3 mt-3">
                                    <div class="row">
                                        <div class="col">
                                            <a @click.prevent="prevCompaniesPage()" v-if="current_companies_page > 1" class="btn-default _sm"><i
                                                    class="fa fa-caret-left"></i></a>
                                            <a class="btn-default _sm">{{ current_companies_page }} / {{ total_companies_pages }}</a>
                                            <a @click.prevent="nextCompaniesPage()" v-if="current_companies_page < total_companies_pages"
                                               class="btn-default _sm"><i class="fa fa-caret-right"></i></a>
                                        </div>
                                        <div class="col align-right">
                                            <div class="mt-1 mb-1">
                                                {{ total_companies_count }} results found
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </template>
                    <hr class="mb-6 mt-6">
                    <div class="align-right mt-3">
                        <button type="submit" class="btn-primary">
                            Update
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";

export default {
    props: [
      'user_id',
     'logged_in_user',
     'commercial_sections',
     'all_company_types',
     'all_epwin_system_types',
     'user_can_be_lead_recipient',
    ],
    components: {
      'datepicker': Datepicker,
    },
    mounted() {
      this.loadUser();
    },
    data() {
        return {
          user: {},
          csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
          change_company_active: false,
          companies: [],
          current_companies_page: 1,
          companies_search_query: '',
          companies_limit: 5,
          total_companies_count: 0,
          total_companies_pages: 0,
          user_access_sections_list: [],
          filter_dropdown_open: false,
          filtering: false,
          selected_company_types: [],
          selected_system_types: [],
          loading: true,
        }
    },
    methods: {
      loadUser() {
        axios.post('/loadUser', {
          user_id: this.user_id,
        }).then((response) => {
          this.user = response.data;
          this.user_access_sections_list = this.user.user_access_sections.map((user_access_section) => user_access_section.id);
          this.loading = false;
        });
      },
      loadCompanies: _.debounce(function() {
        axios.post('/company/loadCompanies', {
          page_number: this.current_companies_page,
          search_query: this.companies_search_query,
          search_on: 'company_name',
          selected_company_types: this.selected_company_types,
          selected_system_types: this.selected_system_types,
          limit: this.companies_limit,
        }).then((response) => {
          this.companies = response.data.data;
          this.total_companies_count = response.data.total;
          this.total_companies_pages = response.data.last_page;
          this.filtering = false;
        });
      }, 250),
      refreshCompanies() {
        this.companies_search_query = '';
        this.current_companies_page = 1;
        this.loadCompanies();
      },
      prevCompaniesPage() {
        this.current_companies_page = this.current_companies_page - 1;
        this.loadCompanies();
      },
      nextCompaniesPage() {
        this.current_companies_page = this.current_companies_page + 1;
        this.loadCompanies();
      },
      save() {
        const validationErrors = Validate({
          'Company': this.user.company_id,
          'Name': this.user.name,
          'Phone': this.user.phone,
          'Email': this.user.email,
        }, {
          'Company': {
            presence: {
              allowEmpty: false,
            },
          },
          'Name': {
            presence: {
              allowEmpty: false,
            },
          },
          'Phone': {
            presence: {
              allowEmpty: false,
            },
          },
          'Email': {
            presence: {
              allowEmpty: false,
            },
            email: true,
          },
        });

        if (validationErrors) {
          Swal.fire({
            title: 'Unable to update user',
            icon: 'error',
            html: `<div class="mb-3">${Object.values(validationErrors).join('</div><div class="mb-3">')}</div>`,
          });
          return;
        }

        document.getElementById('update_customer_form').submit();

      },
      openChangeCompanySection() {
        this.loadCompanies();
        this.change_company_active = true;
      },
    },
  watch: {
    companies_search_query() {
      this.filtering = true;
      this.current_companies_page = 1;
      this.loadCompanies();
    },
    selected_company_types() {
      this.filtering = true;
      this.current_page = 1;
      this.loadCompanies();
    },
    selected_system_types() {
      this.filtering = true;
      this.current_page = 1;
      this.loadCompanies();
    },
    'user.temporary_login'() {
      if(this.user.temporary_login_expires_at === null) {
        let date = new Date();
        date.setMonth(date.getMonth() + 1)
        this.user.temporary_login_expires_at = date;
      }
    },
  },
};
</script>
